// Version 1.1

(function ($) {
    "use strict";

    $.fn.elmToolTip = function (options) {

        var opts = $.extend({}, $.fn.elmToolTip.defaults, options);

        // add tooltip element
        if ($("#elmToolTip").length === 0) {
            $("body").append('<div id="elmToolTip" style="position:absolute;cursor:default;z-index:10000;top:0px;left:0px;height:auto;max-width:500px;opacity:0;text-align:center;"></div>');
        }
                    
        this.each(function () {
            var element = $(this);

            $(this).hover(
                // fade in when cursor enters      
                function () {
                    var timer = opts.tooltip_interval;

                    if ($("#elmToolTip").css("opacity") !== "0") {
                        timer = 0;
                    }

                    clearTimeout(opts.timeoutevent);
                    opts.timeoutevent = setTimeout(function () {
                        var tooltip = $(element).attr("data-elmtooltip");
                        if (tooltip === undefined) {
                            tooltip = "No tooltip";
                        }
                        
                        $("#elmToolTip").html(tooltip);

                        var pos = $(element).attr("data-elmtooltip-position");
                        if (pos === undefined) {
                            pos = "bottom";
                        }
                        else if (opts.positions.indexOf(pos) === -1) { 
                            pos = "bottom";
                        }

                        opts.position = pos.toLowerCase();
                        setpositionclass(pos);    

                        positiontooltip();

                        $("#elmToolTip").stop().animate({ opacity: 1 }, 300);

                        opts.checkpositionevent = setInterval(function () { positiontooltip(); }, 10);

                    }, timer);
                },
                // fade out when cursor leaves       
                function () {
                    hidetooltip();
                }
            );
                
            $(this).click(
                function () {
                    hidetooltip();
                }
            );
            
            function setpositionclass(pos) {
                if (!$("#elmToolTip").is(pos)) {
                    $("#elmToolTip").removeClass(opts.positions);
                    $("#elmToolTip").addClass(pos);
                }
            }
            
            function hidetooltip() {
                clearTimeout(opts.timeoutevent);
                clearInterval(opts.checkpositionevent);

                $("#elmToolTip").stop().animate({ opacity: 0 }, 300, function () { $("#elmToolTip").css({ top: 0, left: 0, display: "none" }); });
            }

            function positiontooltip() {                                      
                var elmw = $(element).outerWidth();
                var elmh = $(element).outerHeight();
                var tw = $("#elmToolTip").outerWidth();
                var th = $("#elmToolTip").outerHeight();

                var l = 0;
                var t = 0;
                
                if (opts.position === "left") {
                    l = $(element).offset().left - (tw + opts.offset);
                    t = $(element).offset().top + ((elmh - th) / 2);

                    if (t < 0) { t = 0; }
                    if (l < 0) { l = 0; }       
                }
                else if (opts.position === "right") {
                    l = $(element).offset().left + elmw + opts.offset;
                    t = $(element).offset().top + ((elmh - th) / 2);

                    if (t < 0) { t = 0; }
                    if (l < 0) { l = 0; }
                    
                    if (l + tw > $(window).width()) {
                        l -= (l + tw) - $(window).width();
                    }                    
                }
                else if (opts.position === "top") {
                    l = $(element).offset().left - ((tw - elmw) / 2);
                    t = $(element).offset().top - (th + opts.offset);

                    if (t < 0) { t = 0; }
                    if (l < 0) { l = 0; }

                    if (l + tw > $(window).width()) {
                        l -= (l + tw) - $(window).width();
                    }                
                }                      
                else { // bottom
                    l = $(element).offset().left - ((tw - elmw) / 2);
                    t = $(element).offset().top + elmh + opts.offset;

                    if (t < 0) { t = 0; }
                    if (l < 0) { l = 0; }

                    if (l + tw > $(window).width()) {
                        l -= (l + tw) - $(window).width();
                    }
                }

                t = Math.round(t);
                l = Math.round(l);

                $("#elmToolTip").css({ top: t, left: l, display: "block" });
            }
        });

        return this;
    };

    $.fn.elmToolTip.defaults = {
        position: "bottom",
        positions: "left top bottom right",
        offset: 10,
        tooltip_interval: 500,
        timeoutevent: 0,
        checkpositionevent: 0
    };

} (jQuery));

